import { createFileRoute } from '@tanstack/react-router'
import { AccountingPage } from '@/features/accounting'

export const Route = createFileRoute('/_authenticated/deposits-company-view/')({
  component: () => (
    <AccountingPage
      kind='deposits'
      accountType='company'
      mode='view'
      reviewPermission='deposit.company.review'
      pageKey='companyView'
    />
  ),
})
